import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {
  static MatchValidator(source:any, target:any) {
    return (control:any) => {
      const sourceCtrl = control.get(source);
      const targetCtrl = control.get(target);

      return sourceCtrl && targetCtrl && sourceCtrl.value !== targetCtrl.value
        ? targetCtrl.setErrors({ confirmedValidator: true })
        : targetCtrl.setErrors(null);;
    };
  }

  static validatePlan(target:any) {
    return (control:FormControl) => {
      const targetCtrl = control.get(target);
      return targetCtrl && targetCtrl.value==1 ? null : {
          required: true
      };
    };
  }

  static noFutureDateValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    const selectedDate = control.value instanceof Date ? control.value : new Date(control.value);
    if (isNaN(selectedDate.getTime())) {
      return null;
    }

    const today = new Date();
    const normalizedSelectedDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate());
    const normalizedToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    return normalizedSelectedDate > normalizedToday ? { futureDate: true } : null;
  }
}
